import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "locked",
  "use": "locked-usage",
  "viewBox": "0 0 512 512",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 512 512\" id=\"locked\"><path d=\"M464 512H48c-8.832 0-16-7.152-16-16V240c0-8.848 7.168-16 16-16h48v-64C96 71.632 167.632 0 256 0s160 71.632 160 160v64h48c8.848 0 16 7.152 16 16v256c0 8.848-7.152 16-16 16zM352 152c0-48.608-42.992-88-96-88s-96 39.392-96 88v72h192v-72z\" /></symbol>"
});
var result = sprite.add(symbol);
export default "#" + symbol.id


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/locked.svg
// module id = o0rf
// module chunks = 1